module.exports = __webpack_public_path__ + "Flag-239.08b7c4aa1d3d60c0f1a3da9e2be4359b.svg";